import { takeLatest } from 'redux-saga/effects';

import * as brandingActions from '../actions';
import { fetchBrandingSaga, resetBrandingSaga } from './branding';

/**
 * The root `branding` saga.
 * We're triggering sagas based on their respective events.
 *
 * @method brandingSaga
 * @type   {Generator}
 */
function* brandingSaga() {
    // Fetch the company branding
    yield takeLatest(brandingActions.fetchBranding.TRIGGER, fetchBrandingSaga);
    // Reset the company branding
    yield takeLatest(brandingActions.resetBranding.TRIGGER, resetBrandingSaga);
}

// Default export is the module's root saga.
export default brandingSaga;

// Named exports are all the internal sagas that can be used
// for testing as well as imports in other modules
export { fetchBrandingSaga };
